import React, {Fragment} from 'react';

import {BookingTypeEnum} from 'presentation/modules/booking/shared/constants/bookingTypeEnum';
import {SimpleConfirmationDrawer} from 'presentation/pages/private/booking/components/ConfirmationDrawer/SimpleConfirmationDrawer';
import {useAdvanceDiagnosticsBookingStore} from 'presentation/pages/private/store/useAdvanceDiagnosticsBookingStore';

import {AdvanceDiagnosticsLocationModal} from '../AdvanceDiagnosticsLocationModal';
import {useAdvanceDiagnosticsExamBooking} from './hooks/useAdvanceDiagnosticsExamBooking';

function AdvanceDiagnosticsBooking() {
	const {step, setStep, closeAdvanceDiagnosticsBooking} = useAdvanceDiagnosticsBookingStore();
	const {startAdvanceDiagnosticsExamBooking} = useAdvanceDiagnosticsExamBooking();

	return (
		<Fragment>
			<SimpleConfirmationDrawer
				isOpened={step === 'confirmation'}
				handleOpen={() => setStep('confirmation')}
				handleClose={closeAdvanceDiagnosticsBooking}
				handleConfirmAndContinue={() => setStep('location')}
				serviceType={BookingTypeEnum.EXAM}
			/>
			<AdvanceDiagnosticsLocationModal
				open={step === 'location'}
				onClose={closeAdvanceDiagnosticsBooking}
				onContinue={() => {
					closeAdvanceDiagnosticsBooking();
					startAdvanceDiagnosticsExamBooking();
				}}
			/>
		</Fragment>
	);
}

export {AdvanceDiagnosticsBooking};
